// PagePaymentFailed Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageSubscription from '../page_subscription/page_subscription.jsx'
import SubscriptionContent from '../../../setting/subscription/subscription_content/subscription_content.jsx'
import DialogTeamCancel from '../../dialog/dialog_teamcancel/dialog_teamcancel.jsx'

// TODO: MAYBE remove as part of CB-16
class PagePaymentFailed extends PageSubscription {
  constructor (props) {
    super(
      props,
      'setting-paymentfailed',
      'setting-user',
      'setting-subscription'
    )

    this.state = {
      dataDate: null
    }

    this.data = {
      teamId: app.getTeamId(),
      team: null,
      subscriptionUpcoming: null,
      idealIssuers: []
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    const { team, subscriptionUpcoming, idealIssuers } = this.data

    return (
      <div className='page-subscription'>
        {team && subscriptionUpcoming && (
          <SubscriptionContent
            team={team || null}
            subscriptionUpcoming={subscriptionUpcoming}
            issuers={idealIssuers}
            isTeamUSA={app.teamCountry === 'US'}
            hideAddonSettings
            hideHeaderStat
            showUpgrade
            upgradeTitle='setting.subscription.paymentFailedContentTitle'
            onPayment={this._onPayment.bind(this)}
            onError={this._onError.bind(this)}
            onCancelAccount={this._onCancelAccount.bind(this)}
          />
        )}
        {this._renderMessage()}
        <DialogTeamCancel
          ref={this._references.refDialogTeamCancel}
          onClose={this._onClose.bind(this)}
          onConfirm={this._onConfirmCancelAccount.bind(this)}
        />
      </div>
    )
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        (done) => {
          this._getPageData(done)
        },
        (done) => {
          this._getDataTeam(done)
        },
        (done) => {
          this._getSubscriptionHistory(done)
        },
        (done) => {
          this._getDataIdealIssuer(done)
        },
        (done) => {
          this._getDataHalfUsers(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getSubscriptionHistory (callback) {
    app
      .service('/api/subscription/history')
      .get(this.props.invoiceId, {})
      .then((hisRes) => {
        this.data.subscriptionUpcoming = hisRes

        callback(null)
      })
      .catch((hisErr) => {
        app.debug('PagePaymentFailed: _getSubscriptionHistory err', hisErr)
        callback(hisErr)
      })
  }

  _onPayment (paymentType, bank) {
    const data = {
      invoiceId: this.props.invoiceId,
      paymentType,
      bank
    }

    app
      .service('/api/payment/repayinvoice')
      .create(data)
      .then((payRes) => {
        if (payRes.redirectUrl) {
          app.redirect(payRes.redirectUrl)
        }
      })
      .catch((payErr) => {
        app.debug('PageSubscription: _onPayment err', payErr)
      })
  }
}

export default PagePaymentFailed
